import { useMemo, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import RequestDetailsSkeleton from "./widgets/skeleton/Skeleton";
import "./style.css";
import PrevOffers from "./widgets/prevOffers";
import ChatWrapper from "./widgets/ChatWrapper";
import DataTable from "./components/dataTable";
import RequestInfo from "./components/requestInfo";
import { usePayment } from "@/Hooks/usePayment";
import { LoadListDefault, useGet } from "@/api/hooks";
import { GetBrokerMedicalRequestDetails } from "@/api/endpoints/Broker/BrokerRequest";
import { Block, CRButton, CRRender } from "@/components/crRender";
import { translate } from "@/utils/langUtils";
import NoData from "@/components/NoData";
import { STATUS_MAP } from "@/data/status";

const MedicalRequestDetails = () => {

    const [isChatOpen, setIsChatOpen] = useState(false);
    const [OpednedFiles, setOpednedFiles] = useState<any>(null);
    const [selectedProvider, setSelectedProvider] = useState<any>(null);


    const [searchParams] = useSearchParams();
    const isPayment = useMemo(() => searchParams.get('isPayment'), [searchParams]);

    const popupRef = useRef<any>(null);
    const PrevRef = useRef<any>(null);

    const navigate = useNavigate();
    const { medicalOrderId } = useParams();

    const { handlePay, paymentLoading } = usePayment();
    const { result: requestDetails, isPending: isRequestDetailsLoading } = useGet({
        ...LoadListDefault,
        allowFetch: !!medicalOrderId,
        endPoint: GetBrokerMedicalRequestDetails,
        params: [medicalOrderId],
        defaultValue: {},
        shortPullTime: 10000
    })

    const proccedRequest = useMemo(() => requestDetails?.availableProviders?.find((provider: any) => provider?.isAccepted), [requestDetails]);

    const AmountToPay = useMemo(() => ({
        sProviderAmount: Math.ceil((selectedProvider?.price * selectedProvider?.downPaymentPercentage) / 100), //direct select
        ProceedAmount: Math.ceil(proccedRequest?.downPayment), // waitin Initial Payment
        CompletePaymentAmount: Math.ceil((proccedRequest?.downPayment)), // waitin Complete Payment
    }), [selectedProvider, proccedRequest]);

    const onPay = (amount) => handlePay(requestDetails?.orderId, requestDetails?.id, amount)

    /*  handleDirectPayment = () => onPay( AmountToPay.sProviderAmount) */
    const handleProceedPayment = () => onPay(AmountToPay.ProceedAmount)
    const handleCompletePayment = () => onPay(AmountToPay.CompletePaymentAmount)

    return (
        <>
            <CRRender isRender={isRequestDetailsLoading}>
                <RequestDetailsSkeleton />
            </CRRender>


            < CRRender isRender={!isRequestDetailsLoading && !!requestDetails?.id}>
                <div className="request-details-with-chat">
                    <div className="request-details-main-content">
                        <Block isRender={!!isPayment} className="payment-notice">
                            <Icon icon="hugeicons:note" width="24" height="24" /> {" "}
                            {translate("Payment may take a few minutes to be reflected in the system")}
                        </Block>
                        <div className="request-details-page">
                            <div className="rd-back-link" onClick={() => navigate(-1)}>
                                <Icon icon="mdi:arrow-left" width={16} />
                                <span>{translate("Back to all requests")}</span>
                            </div>

                            <RequestInfo requestDetails={requestDetails} PrevRef={PrevRef} />

                            <DataTable setIsChatOpen={setIsChatOpen} setOpednedFiles={setOpednedFiles} setSelectedHospital={setSelectedProvider} requestStatusId={requestDetails?.orderStatusId} availableProviders={requestDetails?.availableProviders} />
                            {/* 

                            <CRButton className="rd-proceed-btn" isRender={requestDetails?.orderStatusId == STATUS_MAP.QuotationAvailable && !!selectedProvider?.id}
                                title={`${translate("Proceed")} $ ${Math.ceil((selectedProvider?.price * selectedProvider?.downPaymentPercentage) / 100)}`}
                                loading={paymentLoading} disabled={!selectedProvider?.id} onClick={handleDirectPayment} /> */}

                            <CRButton className={`rd-proceed-btn ${paymentLoading? 'disabled-btn' : ''}`} isRender={requestDetails?.orderStatusId == STATUS_MAP.AwaitingInitialPayment && Math.ceil(proccedRequest?.downPayment) > 0}
                                title={`${translate("Proceed")} $ ${Math.ceil(proccedRequest?.downPayment)}`}
                                loading={paymentLoading} disabled={!proccedRequest?.id || paymentLoading} onClick={handleProceedPayment} />

                            <CRButton className={`rd-proceed-btn ${paymentLoading ? 'disabled-btn' : ''}`} isRender={requestDetails?.orderStatusId >= STATUS_MAP.PreparingForTreatment && requestDetails?.orderStatusId < STATUS_MAP.PaymentCompleted && Math.ceil(proccedRequest?.downPayment) > 0}
                                title={`${translate("Complete Payment")} $ ${Math.ceil(proccedRequest?.downPayment)}`}
                                loading={paymentLoading} disabled={!proccedRequest?.id || paymentLoading} onClick={handleCompletePayment} />

                        </div>
                    </div>

                    <Block isRender={isChatOpen} className="request-details-chat-sidebar">
                        <ChatWrapper popupRef={popupRef} providerOrderId={OpednedFiles} setOpednedFiles={setOpednedFiles} setIsChatOpen={setIsChatOpen} isChatOpen={isChatOpen} />
                    </Block>

                </div>

                <PrevOffers PrevRef={PrevRef} requestId={requestDetails?.id} />
            </CRRender>

            <CRRender isRender={!isRequestDetailsLoading && !requestDetails?.id}>
                <NoData />
            </CRRender>
        </>
    );
};

export default MedicalRequestDetails;

